module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/district/district.component.css
// module id = ./src/app/masters/district/district.component.css
// module chunks = main